<header class="app-header">
  <div class="app-header__left" (click)="navigateHome()">
    <img
      [src]="companyLogoUrl()"
      alt="Company Logo"
      class="app-header__logo"
      (error)="useFallbackLogo()">
  </div>

  <div class="app-header__right">
    <button class="app-header__icon-btn" (click)="navigateToSearch()" aria-label="Search">
      <mat-icon>search</mat-icon>
    </button>

    <button class="app-header__avatar-btn" (click)="navigateToProfile()" aria-label="Profile">
      <hypecast-user-avatar
        [imageUrl]="userAvatarUrl()"
        [firstname]="$safeNavigationMigration(user()?.firstname)"
        [lastname]="$safeNavigationMigration(user()?.lastname)"
        altText="User Avatar"
        size="32px">
      </hypecast-user-avatar>
    </button>
  </div>
</header>
